<template>
    <div>
        <app-data-table
            :fields="fields"
            :items="tableData"
            :current-page="data.current_page"
            @sort="onSort"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        >
            <template slot="due_date" slot-scope="data">
                {{ data.item.due_date | date }}
            </template>

            <template slot="created_at" slot-scope="data">
                {{ data.item.created_at | datetime }}
            </template>

            <template slot="resolution_date" slot-scope="data">
                <div v-if="data.item.resolution_date"> {{ data.item.resolution_date | date }} </div>
                <div v-if="!data.item.resolution_date">Pendiente</div>
            </template>

            <template slot="notes" slot-scope="data">
                <h5><b-badge pill variant="primary">{{ data.item.notes.length }}</b-badge></h5>
            </template>

            <template slot="files" slot-scope="data">
                <h5><b-badge pill variant="primary">{{ data.item.files.length }}</b-badge></h5>
            </template>

            <template slot="row-details" slot-scope="data">
                <app-task-details :the-data="data" />
            </template>

            <template slot="actions" slot-scope="data">
                <b-button size="sm" :variant="!data.detailsShowing?'primary':'danger'" @click.stop="data.toggleDetails"><i v-if="!data.detailsShowing" class="fa fa-eye"></i><i v-else class="fa fa-eye-slash"></i></b-button>
                <b-button size="sm" variant="primary" @click="createNote(data.item)"><i class="fa fa-pencil-square-o"></i></b-button>
                <b-button size="sm" variant="primary" @click="addWatcher(data.item)"><i class="fa fa-user-plus"></i></b-button>
                <b-button size="sm" variant="danger" @click="deleteTask(data.item)"><i class="fa fa-trash"></i></b-button>
            </template>
        </app-data-table>
    </div>    
</template>
<script>
    import fields from './fields';
    import TaskDetails from '../../../../UI/Tasks/TaskDetails.vue';
    import NoDataMessage from '../../../../UI/Layout/NoDataMessage.vue';
    export default {
        components:{
            appTaskDetails: TaskDetails,
            appNoDataMessage: NoDataMessage
        },
        data(){
            return {
                fields: fields
            }
        },
        props: {
            data: {
                required: true
            },
            onChangePage: {
                type: Function,
                required: true
            },
        },
        computed: {
            tableData(){
                if(!this.data || !this.data.data) return [];

                return this.data.data.map(item => {
                    const today = moment();
                    const dueDate = moment(item.due_date);
                    const classes = today.isSame(dueDate, 'day')?'today':(today.isAfter(dueDate)?'overdue': '');
                    const _rowDetails = false;
                    return {...item, _rowDetails, classes};
                })
            }
        },
        methods: {
            seeNotes(data){
                this.$emit('see-notes', data);
            },
            createNote(data){
                this.$emit('create-note', data);
            },
            addWatcher(data){
                this.$emit('add-watcher', data);
            },
            deleteTask(data){
                this.$emit('delete-task', data);
            },
            onSort(ctx) {
                this.$emit('sort', ctx);
            }
        }
    }
</script>
